import PersonalRoutes from '@/routes/personal'

export default [].concat(
    PersonalRoutes
);